export default __webpack_public_path__ + "media/images/icons/icon-burger-menu-close-c409b703083637fe3ccd4e2b44a732e9.svg";